export enum PortalMessageType {
  Bind = 'Bind Quote',
  Bound = 'Bound Quote',
  Canceled = 'Cancelled Quote',
  CustomerSubmission = 'Customer Submission',
  Declined = 'Declined Quote',
  Expired = 'Expired Quote',
  Referred = 'Referred Quote',
  Rejected = 'Rejected Quote',
  CustomerUserBlocking = 'Customer User Blocking',
}
